
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MissionSection from './components/MissionSection';
import CasesSection from './components/CasesSection';
import NewsSection from './components/NewsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MissionSection />
        <CasesSection />
        <NewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
